export default {
  welcome: "Willkommen zurück, {name}",
  subtitle: "Hier ist, was heute mit Ihren Projekten passiert",
  guest: "Gast",
  entity_cards: {
    machines: "Maschinen",
    materials: "Materialien",
    users: "Benutzer",
    projects: "Projekte",
  },
  quick_actions: {
    title: "Schnellaktionen",
    new_badge: "Neu",
    add_user: "Benutzer hinzufügen",
    add_user_subtitle: "Neues Mitarbeiterkonto erstellen",
    add_project: "Projekt erstellen",
    add_project_subtitle: "Neues Projekt anlegen",
    visit_costs: "Mitlaufende Nachkalkulation",
    visit_costs_subtitle: "Projektkosten ansehen",
    visit_hourlywageinvoice: "[[hwi]]",
    visit_hourlywageinvoice_subtitle: "Abrechnung erstellen",
    visit_timetracking: "Zeiterfassung",
    visit_timetracking_subtitle: "Arbeitszeiten erfassen und freigeben",
    visit_files: "Dateien",
    visit_files_subtitle: "Alle Dokumente an einem Ort",
    visit_personnelplanning: "Personalplanung",
    visit_personnelplanning_subtitle: "Einsätze der Mitarbeiter planen",
    add_customer: "Kunde anlegen",
    add_customer_subtitle: "Neuen Kunden erfassen",
    add_material: "Material anlegen",
    add_material_subtitle: "Neues Material erfassen",
    add_machine: "Maschine anlegen",
    add_machine_subtitle: "Neue Maschine erfassen",
    add_additionaleffort: "Zusatzleistung anlegen",
    add_additionaleffort_subtitle: "Neue Zusatzleistung erfassen",
    visit_projects: "Projekte",
    visit_projects_subtitle: "Alle Projekte ansehen",
  },
  recent_projects: {
    title: "Zuletzt besuchte Projekte",
    empty: "Keine aktuellen Projekte",
  },
  recent_activity: {
    title: "Letzte Aktivitäten",
    show_all: "Alle anzeigen",
    empty: "Keine aktuellen Aktivitäten",
  },
}
